exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@charset \"UTF-8\";\nul {\n  list-style: none;\n  /* Remove default bullets */\n  font-size: 16px;\n  line-height: 24px;\n}\nul li::before {\n  content: \"\\2022\";\n  /* Add content: \\2022 is the CSS Code/unicode for a bullet */\n  color: #0071DB;\n  /* Change the color */\n  font-weight: bold;\n  /* If you want it to be bold */\n  display: inline-block;\n  /* Needed to add space between the bullet and the text */\n  width: 1em;\n  /* Also needed for space (tweak if needed) */\n  margin-left: -1em;\n  /* Also needed for space (tweak if needed) */\n}\n/* width */\n::-webkit-scrollbar {\n  height: 4px;\n}\n/* Track */\n::-webkit-scrollbar-track {\n  background: #EDEDED;\n}\n/* Handle */\n::-webkit-scrollbar-thumb {\n  background: #0071DB;\n}\n/* Handle on hover */\n::-webkit-scrollbar-thumb:hover {\n  background: #0071DB;\n}\n@media screen and (max-width: 991px) {\n  ::-webkit-scrollbar {\n    display: none;\n  }\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/matthijs/projects/PHILIPS/philips-dental-pro/shop/src/app/pages/instructie/instructie.component.scss
// module id = ../../../../../src/app/pages/instructie/instructie.component.scss
// module chunks = main